import { createSlice } from '@reduxjs/toolkit';
import AuthService from '../../../../../../services/auth.service';
import { createAppAsyncThunk } from '../../../../../../common/thunk';
import httpErrorHandling from '../../../../../../utils/httpErrorHandling';

interface SignupState {
  email: string,
  readyToLogin: boolean,
  accessToken: string,
  refreshToken: string,
  resendCodeSuccessful: boolean,
  error: string | null | undefined
}

interface ConfirmCodeAttributes {
  email: string,
  code: string
}

export const confirmCode = createAppAsyncThunk('auth/confirmCode', async (attr: ConfirmCodeAttributes) => {
  return await AuthService.signupConfirm(attr.email, attr.code).then(response => response.data);
})

export const resendCode = createAppAsyncThunk('auth/resendCode', async (email: string) => {
  return await AuthService.resendCode(email).then(response => response.data);
})

const initialState: SignupState = {
  email: '',
  readyToLogin: false,
  accessToken: '',
  refreshToken: '',
  resendCodeSuccessful: false,
  error: null
}
export const signupConfirmSlice = createSlice({
  name: 'signupConfirm',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(confirmCode.fulfilled, (state) => {
      state.readyToLogin = true;
    })
    builder.addCase(confirmCode.rejected, (state, action) => {
      state.readyToLogin = false;
      state.error = httpErrorHandling(action);
    })
    builder.addCase(confirmCode.pending, state => {
      state.error = '';
    })
    builder.addCase(resendCode.fulfilled, state => {
      state.resendCodeSuccessful = true;
    })
    builder.addCase(resendCode.pending, state => {
      state.resendCodeSuccessful = false;
    })
    builder.addCase(resendCode.rejected, (state, action) => {
      state.error = httpErrorHandling(action)
    })
  }
})

export default signupConfirmSlice.reducer